var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("BIENVENIDO")])])
}
var staticRenderFns = []

export { render, staticRenderFns }